import React from 'react';
import BuilderSelectMenu from '../../../components/Builder/BuilderSelectMenu';
import {
  DevPermission,
  devPermissionOptions,
  setDevPermission,
} from '../../../redux/slices/permission';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';

/**
 * This component is used to control the permission by developers and QAs in local env.
 */
const DevPermissionControl = () => {
  const dispatch = useAppDispatch();
  const devPermission = useAppSelector(
    (state) => state.permission.devPermission,
  );
  const onChange = (val: string) => {
    let value = null;
    switch (val) {
      case DevPermission.ForceDisable:
        value = DevPermission.ForceDisable;
        break;
      case DevPermission.ForceEnable:
        value = DevPermission.ForceEnable;
        break;
      default:
        value = DevPermission.Default;
    }
    dispatch(setDevPermission({ devPermission: value }));
  };
  return (
    <BuilderSelectMenu
      label={'Dev Permission'}
      options={devPermissionOptions}
      value={devPermission}
      onChange={onChange}
    />
  );
};

export default DevPermissionControl;
